// start:ng42.barrel
export * from './IResDirectNumber';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/ResDirect/index.ts